import { WbGood } from "./parseWb/parseWbGood";
import type { MarketplaceKey } from "@/marketplaces/registry";
import type { AiStrategyBundle } from "@/types/improvement";
import { orchestrateCatalogText } from "./geniAiOrchestration";

export type AIVariant = {
  id: string;
  text: string;
  source?: "manual" | "ai";
};

export async function generateTitleVariants(
  productName = "Товар",
  description = "Описание товара",
  characteristics: { name: string; value: string }[] | null = null,
  _competitors: WbGood[] = [],
): Promise<AIVariant[]> {
  return (await orchestrateCatalogText("title_variants", {
    productName,
    description,
    characteristics,
  })) as AIVariant[];
}

export async function generateDescriptionVariants(
  productName = "Товар",
  description = "Описание товара",
  characteristics: { name: string; value: string }[] | null = null,
  _competitors: WbGood[] = [],
): Promise<AIVariant[]> {
  return (await orchestrateCatalogText("description_variants", {
    productName,
    description,
    characteristics,
  })) as AIVariant[];
}

export type MarketplaceTextContext = {
  marketplaceDisplayName: string;
  policyJson: string;
};

export async function generateAnotherVariant(
  kind: "title" | "description",
  productName = "Товар",
  description = "Описание товара",
  characteristics: { name: string; value: string }[] | null = null,
  competitors: WbGood[] = [],
  marketplaceContext?: MarketplaceTextContext,
): Promise<AIVariant> {
  return (await orchestrateCatalogText("another_variant", {
    kind,
    productName,
    description,
    characteristics,
    competitors,
    marketplaceDisplayName: marketplaceContext?.marketplaceDisplayName,
    policyJson: marketplaceContext?.policyJson,
  })) as AIVariant;
}

export type DeepAnalysisMarketplaceOptions = {
  marketplace: MarketplaceKey;
  marketplaceDisplayName: string;
  policyJson: string;
  generationNotes?: string;
  imagePlanJson?: string;
  categoryLabel?: string;
};

export async function generateDeepAnalysisStrategies(
  productName: string,
  description: string,
  characteristics: { name: string; value: string }[] | null,
  competitors: WbGood[],
  options: DeepAnalysisMarketplaceOptions,
): Promise<AiStrategyBundle[]> {
  return (await orchestrateCatalogText("deep_strategies", {
    productName,
    description,
    characteristics,
    competitors,
    marketplace: options.marketplace,
    marketplaceDisplayName: options.marketplaceDisplayName,
    policyJson: options.policyJson,
    generationNotes: options.generationNotes ?? "",
    imagePlanJson: options.imagePlanJson ?? "",
    categoryLabel: options.categoryLabel ?? "",
  })) as AiStrategyBundle[];
}

export async function refineTextByUserPrompt(args: {
  kind: "title" | "description";
  currentText: string;
  productTitle: string;
  productDescription: string;
  userPrompt: string;
  characteristics: { name: string; value: string }[] | null;
  marketplaceContext?: MarketplaceTextContext;
}): Promise<string> {
  const result = (await orchestrateCatalogText("refine_text", {
    kind: args.kind,
    currentText: args.currentText,
    productTitle: args.productTitle,
    productDescription: args.productDescription,
    userPrompt: args.userPrompt,
    characteristics: args.characteristics,
    marketplaceDisplayName: args.marketplaceContext?.marketplaceDisplayName,
    policyJson: args.marketplaceContext?.policyJson,
  })) as { text?: unknown };
  return typeof result?.text === "string" ? result.text : "";
}
